import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { openedTasksComponent } from './openedTasks.component';

@NgModule({
  declarations: [openedTasksComponent],
  imports: [TranslateModule, CommonModule, RouterModule],
  exports: [openedTasksComponent]
})
export class OpenedTasksModule { }
